import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import { FiSave } from "react-icons/fi";
import useUserLanguage from "../../hooks/useUserLanguage";
import useTranslations from "../../hooks/useTranslations";

const BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/api/redirects`;


const RedirectEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const language = useUserLanguage();
  const { translations } = useTranslations(language);
  const getText = (key, fallback = "") => translations[key] || fallback;

  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    url: "",
    redirect_url: "",
  });

  // Veri çek
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/${id}`);
        setFormData({
          url: res.data.url || "",
          redirect_url: res.data.redirect_url || "",
        });
      } catch (err) {
        toast.error(getText("ERROR_FETCH_DATA"));
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id]);

  // Inputlar
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Güncelle
  const handleUpdate = async () => {
    if (!formData.url.trim() || !formData.redirect_url.trim()) {
      toast.warn(getText("WARNING_ADD_VALID_ROW"));
      return;
    }

    try {
      await axios.put(`${BASE_URL}/${id}`, formData);
      toast.success(getText("REDIRECT_UPDATED"));
      
    } catch (err) {
      toast.error(getText("REDIRECT_UPDATE_FAILED"));
    }
  };

  if (loading) {
    return (
      <div className="text-center my-4">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">{getText("LOADING")}</span>
        </div>
      </div>
    );
  }

  return (
    <div className="container mt-4">
      <ToastContainer />
      <div className="card card-body">
        <h4 className="fw-bold text-primary mb-4">{getText("EDIT_REDIRECT")}</h4>

        <div className="mb-3">
          <label className="form-label fw-bold">{getText("TABLE_URL_LABEL")}</label>
          <input
            type="text"
            name="url"
            className="form-control"
            value={formData.url}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label className="form-label fw-bold">{getText("LABEL_REDIRECT_URL")}</label>
          <input
            type="text"
            name="redirect_url"
            className="form-control"
            value={formData.redirect_url}
            onChange={handleChange}
          />
        </div>

        <div className="d-flex justify-content-center">
          <button className="btn btn-primary" onClick={handleUpdate}>
            <FiSave /> {getText("SAVE_BTN")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RedirectEdit;
